module.exports = __webpack_public_path__ + "img/zyncro-logo.ed13bbed.svg";